import { forwardRef } from 'react';

import { messages } from './EmailField.messages';
import { Field, Label, StyledTextEditor, ValidationMessage } from './EmailField.styles';
import { EmailFieldProps } from './EmailField.types';

const EmailField = forwardRef<HTMLInputElement, EmailFieldProps>((props, ref) => {
    const { value, validationError, onChange } = props;

    return (
        <Field>
            <Label htmlFor='email'>{messages.emailLabelText}</Label>

            <StyledTextEditor
                theme='auth'
                qa='login-page__email-input'
                invalid={Boolean(validationError)}
                ref={ref}
                value={value}
                type='text'
                name='email'
                autoComplete='on'
                spellCheck={false}
                onChange={onChange}
                placeholder={validationError ? undefined : messages.placeholderText}
            />

            {validationError && <ValidationMessage>{validationError}</ValidationMessage>}
        </Field>
    );
});

export default EmailField;
